import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { format } from "date-fns"
import { Modal, Spinner } from "react-bootstrap"
import {
  ignoreAssignmentRequiredETA,
  resolveAssignmentRequiredETA
} from "requesters/jobServiceRequester"
import { useSelector } from "react-redux";
import { getBaseUrl } from "../../../reducers";

const RequiredEtaModal = ({
  show, onHide, jobService, reloadData, assignmentData
}) => {
  const baseUrl = useSelector(getBaseUrl)
  const [estimatedTimeOfArrival, setEstimatedTimeOfArrival] = useState(null)
  const [requesting, setRequesting] = useState(false)
  const [assignment, setAssignment] = useState(assignmentData || {})
  const {
    surveyorAssignmentId: id,
    requiredRespondEtaAt,
    estimatedTimeOfArrival: submittedEstimatedTimeOfArrival,
    respondEtaResolvedAt,
    disableRequiredRespondEta
  } = assignment

  const onIgnoreAssignmentRequiredETA = () => {
    const params = {
      surveyor_assignment_id: id,
    }
    setRequesting(true)
    ignoreAssignmentRequiredETA(baseUrl, jobService.id, params)
    .then(res => {
      if (res.status === 200) {
        reloadData()
        onHide()
      }
    })
    // eslint-disable-next-line no-console
    .catch(err => console.log(err))
    .finally(() => setRequesting(false))
  }

  const onSubmitETA = () => {
    const params = {
      surveyor_assignment_id: id,
      estimated_time_of_arrival: estimatedTimeOfArrival
    }
    setRequesting(true)
    resolveAssignmentRequiredETA(baseUrl, jobService.id, params)
    .then(res => {
      if (res.status === 200) {
        reloadData()
        onHide()
      }
    })
    // eslint-disable-next-line no-console
    .catch(err => console.log(err))
    .finally(() => setRequesting(false))
  }

  useEffect(() => {
    setAssignment(assignmentData || {})
  }, [assignmentData])

  useEffect(() => {
    setEstimatedTimeOfArrival(submittedEstimatedTimeOfArrival ? new Date(submittedEstimatedTimeOfArrival) : null)
  }, [submittedEstimatedTimeOfArrival])

  if (disableRequiredRespondEta) return <></>;

  return (
    <Modal show={show} onHide={onHide} size="lg" centered className="required-eta-modal">
      <Modal.Header closeButton>
        <div>
          <h2 className="modal-title">Required ETA</h2>
          <div className="pt-2">
            <div>
              <span>Required ETA enable at</span>
              <span className="ml-1 font-weight-bold">{format(new Date(requiredRespondEtaAt), "dd MMM yyyy, EEEE h:mm aa")}</span>
            </div>
            { respondEtaResolvedAt && submittedEstimatedTimeOfArrival && (
              <p>
                <span>Submitted ETA:</span>
                <span className="ml-2 font-weight-bold">{format(new Date(submittedEstimatedTimeOfArrival), "dd MMM yyyy, EEEE h:mm aa")}</span>
              </p>
            )}
          </div>
        </div>
      </Modal.Header>
      <div className="modal-body px-md-5">
        <form>
          <div className="form-group row mb-3 align-items-center">
            <label className="col-5 mb-0">Estimated Time of Arrival</label>
            <div className="col-7">
              <DatePicker
                required
                selected={estimatedTimeOfArrival}
                onChange={date => {
                  setEstimatedTimeOfArrival(date)
                }}
                showTimeSelect
                timeFormat="hh:mm aa"
                timeCaption="time"
                timeIntervals={1}
                includeDates={[estimatedTimeOfArrival]}
                closeOnScroll={e => e.target === document}
                className="form-control"
                dateFormat="dd/MM/yyyy, hh:mm aa" />
            </div>
          </div>
        </form>
        <div className="modal-footer d-flex justify-content-right px-0 py-4">
          { respondEtaResolvedAt ? (
            <button
              className="btn btn-primary btn-lg"
              disabled={!estimatedTimeOfArrival || requesting}
              onClick={onSubmitETA}
              type="button">
              Change ETA
              {requesting && <Spinner animation="border" role="status" size="sm" />}
            </button>
          ) : (
            <>
              <button
                className="btn btn-red btn-lg"
                onClick={onIgnoreAssignmentRequiredETA}
                disabled={requesting}
                type="button">
                Disable Required ETA
                {requesting && <Spinner animation="border" role="status" size="sm" />}
              </button>
              <button
                className="btn btn-primary btn-lg"
                disabled={!estimatedTimeOfArrival || requesting}
                onClick={onSubmitETA}
                type="button">
                Submit ETA
                {requesting && <Spinner animation="border" role="status" size="sm" />}
              </button>
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default RequiredEtaModal